// extracted by mini-css-extract-plugin
export default {"myprofile":"myprofile_myprofile__RUVYF","promenu":"myprofile_promenu__dxPAO","probody":"myprofile_probody__kBBDM"};